import { render } from "./RestoreOrder.vue?vue&type=template&id=021037d6&scoped=true"
import script from "./RestoreOrder.vue?vue&type=script&lang=js"
export * from "./RestoreOrder.vue?vue&type=script&lang=js"

import "@/assets/css/style.css?vue&type=style&index=0&id=021037d6&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-021037d6"]])

export default __exports__